import { commonOpenGraphMeta, defaultMetaData } from "@/lib/constants/common";
import { getStrapiMedia } from "@repo/lib/utils";

export async function generateStrapiMetadata(fetchPageFn, slug, locale) {
  const meta = await fetchPageFn(slug, locale);
  const { seo } = meta?.data?.[0] || {};
  const shareImg = seo?.shareImage;

  return {
    title: seo?.metaTitle || defaultMetaData?.title,
    description: seo?.metaDescription || defaultMetaData?.description,
    openGraph: {
      title: seo?.metaTitle || defaultMetaData?.title,
      description: seo?.metaDescription || defaultMetaData?.description,
      images: [
        {
          url: getStrapiMedia(shareImg?.url) || "",
          width: shareImg?.width || 0,
          height: shareImg?.height || 0,
        },
      ],
      ...commonOpenGraphMeta,
    },
  };
}
